var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{attrs:{"id":"home"}},[(!_vm.isContentLoaded)?_c('v-progress-linear',{attrs:{"fixed":true,"color":"primary","indeterminate":""}}):_vm._e(),(_vm.hasCommonLayout)?_c('layout-main'):_c('layout-additional')],1)}
var staticRenderFns = []

export { render, staticRenderFns }